var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/utils.ts
import axios from "axios";
import { encodingForModel } from "js-tiktoken";
var BASE_URL = "https://api.tavily.com";
var DEFAULT_MODEL_ENCODING = "gpt-3.5-turbo";
var DEFAULT_MAX_TOKENS = 4e3;
function post(endpoint, body, apiKey) {
  return __async(this, null, function* () {
    const url = `${BASE_URL}/${endpoint}`;
    const headers = {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${apiKey}`
    };
    return axios.post(url, body, { headers });
  });
}
function getTotalTokensFromString(str, encodingName = DEFAULT_MODEL_ENCODING) {
  const encoding = encodingForModel(encodingName);
  return encoding.encode(str).length;
}
function getMaxTokensFromList(data, maxTokens = DEFAULT_MAX_TOKENS) {
  var result = [];
  let currentTokens = 0;
  for (let item of data) {
    let itemString = JSON.stringify(item);
    let newTotalTokens = currentTokens + getTotalTokensFromString(itemString);
    if (newTotalTokens > maxTokens) {
      break;
    }
    result.push(item);
    currentTokens = newTotalTokens;
  }
  return JSON.stringify(result);
}

// src/search.ts
function _search(apiKey) {
  return function search(_0) {
    return __async(this, arguments, function* (query, options = {
      searchDepth: "basic",
      topic: "general",
      days: 3,
      maxResults: 5,
      includeImages: false,
      includeImageDescriptions: false,
      includeAnswer: false,
      includeRawContent: false,
      includeDomains: void 0,
      excludeDomains: void 0,
      maxTokens: void 0,
      timeRange: void 0
    }) {
      const _a = options, {
        searchDepth,
        topic,
        days,
        maxResults,
        includeImages,
        includeImageDescriptions,
        includeAnswer,
        includeRawContent,
        includeDomains,
        excludeDomains,
        timeRange
      } = _a, kwargs = __objRest(_a, [
        "searchDepth",
        "topic",
        "days",
        "maxResults",
        "includeImages",
        "includeImageDescriptions",
        "includeAnswer",
        "includeRawContent",
        "includeDomains",
        "excludeDomains",
        "timeRange"
      ]);
      const response = yield post("search", __spreadValues({
        query,
        search_depth: searchDepth,
        topic,
        days,
        max_results: maxResults,
        include_images: includeImages,
        include_image_descriptions: includeImageDescriptions,
        include_answer: includeAnswer,
        include_raw_content: includeRawContent,
        include_domains: includeDomains,
        exclude_domains: excludeDomains,
        time_range: timeRange
      }, kwargs), apiKey);
      return {
        query,
        responseTime: response.data.response_time,
        images: response.data.images.map((image) => {
          return {
            url: (image == null ? void 0 : image.url) || image,
            description: image.description
          };
        }),
        results: response.data.results.map((result) => {
          return {
            title: result.title,
            url: result.url,
            content: result.content,
            rawContent: result.raw_content,
            score: result.score,
            publishedDate: result.published_date
          };
        }),
        answer: response.data.answer
      };
    });
  };
}
function _searchQNA(apiKey) {
  return function searchQNA(_0) {
    return __async(this, arguments, function* (query, options = {
      searchDepth: "advanced",
      topic: "general",
      days: 3,
      maxResults: 5,
      includeImages: false,
      includeImageDescriptions: false,
      includeAnswer: false,
      includeRawContent: false,
      includeDomains: void 0,
      excludeDomains: void 0,
      maxTokens: void 0
    }) {
      const response = yield post("search", {
        query,
        search_depth: options.searchDepth,
        topic: options.topic,
        days: options.days,
        max_results: options.maxResults,
        include_images: false,
        include_image_descriptions: false,
        include_answer: true,
        include_raw_content: false,
        include_domains: options.includeDomains,
        exclude_domains: options.excludeDomains
      }, apiKey);
      const answer = response.data.answer;
      return answer;
    });
  };
}
function _searchContext(apiKey) {
  return function searchContext(_0) {
    return __async(this, arguments, function* (query, options = {
      searchDepth: "basic",
      topic: "general",
      days: 3,
      maxResults: 5,
      includeImages: false,
      includeImageDescriptions: false,
      includeAnswer: false,
      includeRawContent: false,
      includeDomains: void 0,
      excludeDomains: void 0,
      maxTokens: DEFAULT_MAX_TOKENS
    }) {
      var _a;
      const response = yield post("search", {
        query,
        search_depth: options.searchDepth,
        topic: options.topic,
        days: options.days,
        max_results: options.maxResults,
        include_images: false,
        include_image_descriptions: false,
        include_answer: false,
        include_raw_content: false,
        include_domains: options.includeDomains,
        exclude_domains: options.excludeDomains,
        max_tokens: options.maxTokens
      }, apiKey);
      const sources = ((_a = response.data) == null ? void 0 : _a.results) || [];
      const context = sources.map((source) => {
        return {
          url: source.url,
          content: source.content
        };
      });
      return JSON.stringify(getMaxTokensFromList(context, options.maxTokens));
    });
  };
}

// src/extract.ts
function _extract(apiKey) {
  return function extract(_0) {
    return __async(this, arguments, function* (urls, options = {
      includeImages: false,
      extractDepth: "basic"
    }) {
      const _a = options, {
        includeImages,
        extractDepth
      } = _a, kwargs = __objRest(_a, [
        "includeImages",
        "extractDepth"
      ]);
      const response = yield post("extract", __spreadValues({
        urls,
        include_images: includeImages,
        extract_depth: extractDepth
      }, kwargs), apiKey);
      return {
        responseTime: response.data.response_time,
        results: response.data.results.map((result) => {
          return {
            url: result.url,
            rawContent: result.raw_content,
            images: result.images
          };
        }),
        failedResults: response.data.failed_results.map((result) => {
          return {
            url: result.url,
            error: result.error
          };
        })
      };
    });
  };
}

// src/client.ts
function tavily(options) {
  const apiKey = (options == null ? void 0 : options.apiKey) || process.env.TAVILY_API_KEY;
  if (!apiKey) {
    throw new Error("No API key provided");
  }
  return {
    search: _search(apiKey),
    extract: _extract(apiKey),
    searchQNA: _searchQNA(apiKey),
    searchContext: _searchContext(apiKey)
  };
}
export {
  tavily
};
//# sourceMappingURL=index.mjs.map